class TranscriptFormatter {
  transcriptSplitter(transcript: string): string[] {
    const lines = transcript.split(/\[(?=[A-Za-z])/);

    // Remove empty lines and add back the [
    const filteredLines = lines
      .filter(line => line.trim() !== '')
      .map(line => `[${line.trim()}`);

    return filteredLines;
  }
}

export const transcriptFormatter = new TranscriptFormatter();
